import React, { useState, useEffect } from 'react';
import { generateClient } from 'aws-amplify/api';
import { listBlogPosts } from '../graphql/queries';
import { deleteBlogPost } from '../graphql/mutations';
import BlogPostForm from './BlogPostForm';
import { Trash2 } from 'lucide-react';
import './ContentManagement.css';

const ContentManagement = () => {
  const [blogPosts, setBlogPosts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const client = generateClient();

  useEffect(() => {
    fetchBlogPosts();
  }, []);

  async function fetchBlogPosts() {
    setIsLoading(true);
    setError(null);
    try {
      const blogPostData = await client.graphql({
        query: listBlogPosts
      });
      setBlogPosts(blogPostData.data.listBlogPosts.items);
    } catch (err) {
      console.error('Error fetching blog posts:', err);
      setError('An error occurred while fetching blog posts. Please try again.');
    } finally {
      setIsLoading(false);
    }
  }

  async function handleDeleteBlogPost(id) {
    try {
      await client.graphql({
        query: deleteBlogPost,
        variables: { input: { id } }
      });
      setBlogPosts(blogPosts.filter(post => post.id !== id));
      console.log('Blog post deleted successfully');
    } catch (err) {
      console.error('Error deleting blog post:', err);
      setError('An error occurred while deleting the blog post. Please try again.');
    }
  }

  if (isLoading) {
    return <div>Loading blog posts...</div>;
  }

  if (error) {
    return <div className="error-message">{error}</div>;
  }

  return (
    <div className="content-management">
      <h1>Content Management</h1>
      
      <section className="blog-post-list">
        <h2>Existing Blog Posts</h2>
        {blogPosts.length === 0 ? (
          <p>No blog posts found.</p>
        ) : (
          <ul>
            {blogPosts.map(post => (
              <li key={post.id} className="blog-post-item">
                <div className="blog-post-info">
                  <h3>{post.title}</h3>
                  <p>Author: {post.author}</p>
                  <p>Published: {new Date(post.publishDate).toLocaleDateString()}</p>
                </div>
                <button 
                  onClick={() => handleDeleteBlogPost(post.id)}
                  className="delete-button"
                  aria-label={`Delete ${post.title}`}
                >
                  <Trash2 size={18} />
                </button>
              </li>
            ))}
          </ul>
        )}
      </section>

      <section className="add-new-post">
        <h2>Add New Blog Post</h2>
        <BlogPostForm onPostCreated={fetchBlogPosts} />
      </section>
    </div>
  );
};

export default ContentManagement;